
export const Conditional = ({ children, ...props }) => (
  props.if ? children : null
)
